import React from 'react';
import GoogleStudioDashboard from './GoogleStudioDashboard';

const GDashboard = (props) => {
    const { match } = props;
    const reportId = (match.params || {}).reportId;
    return (
        <GoogleStudioDashboard
            report_id = {reportId}
        />
    )
}

export default GDashboard;